module.exports = __webpack_public_path__ + "static/media/Ellipse 3.89f1725e.png";